export default "__VITE_ASSET__3dbb3e4c__"